<script lang="ts">
	import { getJsonLdScriptTag } from './utils/getJsonLdScriptTag/getJsonLdScriptTag';
	import { page } from '$app/state';
	import type { NewsArticlePDPPageData } from '$routes/news/article/[slug]/types';

	let data = $derived(page.data as NewsArticlePDPPageData);

	let jsonLd = $derived(getJsonLdScriptTag(data));
</script>

<svelte:head>
	<!-- eslint-disable-next-line svelte/no-at-html-tags -->
	{@html jsonLd}
</svelte:head>
